// cjeApi.js
import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
    process.env.REACT_APP_PUBLIC_SUPABASE_URL,
    process.env.REACT_APP_PUBLIC_SUPABASE_ANON_KEY,
);

export const todayDateOnly = () =>
    new Date().toLocaleDateString("sv-SE", { timeZone: "Atlantic/Canary" });

export const formatDateOnly = (d) =>
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0");

export const parseYMD = (s) => {
    const [y, m, d] = s.split("-").map(Number);
    return new Date(y, m - 1, d);
};

export const estados = {
    sin_comprobar: "Sin comprobar",
    pendiente: "Formulario pendiente",
    revisar: "Formulario a revisar",
    completo: "Formulario completo",
};

const fotos = new Map();

export const readAll = async (query) => {
    const rows = [];

    for (let start = 0; ; start += 500) {
        const { data, error } = await query.range(start, start + 499);
        if (error) throw error;

        rows.push(...data);
        if (data.length < 500) return rows;
    }
};

export const withPhotos = async (rows) => {
    const paths = [
        ...new Set(
            rows
                .map((n) => n.foto_path)
                .filter(
                    (p) =>
                        p &&
                        (!fotos.has(p) || fotos.get(p).expires < Date.now()),
                ),
        ),
    ];

    if (paths.length) {
        const { data, error } = await supabase.storage
            .from("NiniosFotos")
            .createSignedUrls(paths, 3600);

        if (!error) {
            data.forEach((p) => {
                if (p.signedUrl) {
                    fotos.set(p.path, {
                        url: p.signedUrl,
                        expires: Date.now() + 50 * 60 * 1000,
                    });
                }
            });
        }
    }

    return rows.map((n) => ({
        ...n,
        signedUrl:
            fotos.get(n.foto_path)?.expires > Date.now()
                ? fotos.get(n.foto_path).url
                : null,
    }));
};
